export const PRO_CATEGORIES = {
  abonnements: "Abonnements logiciels", web_hosting: "Sites, domaines et hébergements",
  marketing: "Marketing, communication et publicité", materiel: "Matériel informatique et équipements",
  telecom: "Téléphone et Internet", deplacements: "Déplacements, carburant et péages",
  repas: "Repas et invitations clients", loyer_pro: "Loyer professionnel et coworking",
  banque: "Banque et frais bancaires", assurance_pro: "Assurance professionnelle",
  sous_traitance: "Prestataires et sous-traitance", comptable: "Comptable et frais administratifs",
  formations: "Formations", autres_pro: "Autres dépenses professionnelles",
};
export const PERSO_CATEGORIES = {
  loyer: "Loyer et charges du logement", courses: "Courses alimentaires",
  energie: "Électricité, eau et chauffage", telecom_perso: "Internet et téléphone personnels",
  transport: "Transport et carburant", assurances: "Assurance habitation et voiture",
  sante: "Mutuelle et santé", credits: "Crédits et remboursements",
  restaurants: "Restaurants et sorties", shopping: "Shopping",
  loisirs: "Loisirs et vacances", epargne: "Épargne et investissements",
  impots_perso: "Impôts personnels", autres_perso: "Autres dépenses",
};
export const FREQUENCIES = { ponctuelle: "Ponctuelle", mensuelle: "Mensuelle", trimestrielle: "Trimestrielle", annuelle: "Annuelle" };
export const catsFor = (type) => (type === "pro" ? PRO_CATEGORIES : PERSO_CATEGORIES);
export const catLabel = (type, id) => catsFor(type)[id] || id;
export const pctFmt = (v) => `${v > 0 ? "+" : ""}${v} %`;
export const deltaVs = (cur, prev) => {
  const d = Math.round((cur - prev) * 100) / 100;
  const pct = prev ? Math.round((cur - prev) / Math.abs(prev) * 1000) / 10 : null;
  return { amount: d, pct };
};
